import { create } from "zustand";

export const useStoreComodities = create((set, get) => ({
  comodities: [],
  handleUpdateComodities: (payload) => {
    set(() => ({ comodities: payload }));
  },
}));
